import React from "react";
import clsx from "clsx";

import CancelIcon from "../../../images/cancel.svg";
import "./alert.css";

function Alert(props) {
  const { alertMessage, status } = props;
  function closeModal() {
    document.getElementById("myModal").style.display = "none";
  }

  React.useEffect(() => {
    if (props.alertMessage && props.alertMessage) {
      document.getElementById("myModal").style.display = "block";
    }
  }, [props.alertMessage, props.success]);


  return (
    <>
      <div id="myModal" className="modal">
        <div
          className={clsx(
            "modal-content",
            status === "success" ? "success" : "failure",
          )}
        >
          <div className="middle-content">
            <div className="circle-icon">
              {status === 'success' ? (
                <i className="material-icons">check</i>
              ) : (
                <i className="material-icons">error_outline</i>
              )}
            </div>
            <span>{alertMessage}</span>
          </div>
          <span onClick={closeModal}>
            <img src={CancelIcon} alt="CancelIcon" width="20" />
          </span>
        </div>
      </div>
    </>
  );
}

export default Alert;
